import { Fragment } from "react/jsx-runtime";
import { Controller, useForm } from "react-hook-form";
import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import {
  DocumentData,
  useDocuments,
} from "../../../../GuestOffer/hooks/useDocuments";
import MaskInput from "../../../../../components/Controls/MaskInput";
import Button from "../../../../../components/form/Button";
import { useSelector } from "react-redux";
import { AppStore } from "../../../../../redux/store";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCustomerProfile } from "../../../../Account/EditProfile/hooks/useProfile";
import { TabsComponentProps } from "../TabsComponent";

interface DocumentForm {
  document_number: string;
  document_type: string;
}
const DocumentForm = ({ customerInfo }: TabsComponentProps) => {
  const {
    editData,
    errorMessage,
    errorMessageText,
    successMessageText,
    successMessage,
  } = useCustomerProfile();
  const { country } = useSelector((store: AppStore) => store.country);
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<DocumentForm>({
    resolver: yupResolver(
      yup
        .object({
          document_number: yup
            .string()
            .required("El numero de documento es requerido"),
          document_type: yup
            .string()
            .required("El tipo de documento es requerido"),
        })
        .required()
    ),
  });
  const { getDataDocuments, loading, documents } = useDocuments();
  const [documentMask, setDocumentMask] = useState<string>("");

  useEffect(() => {
    getDataDocuments(country.toUpperCase());
  }, [country]);

  // Autocompletar valores existentes del cliente
useEffect(() => {
  getDataDocuments(country.toUpperCase());
}, [country]);

// Autocompletar valores existentes del cliente
// Cuando cargan los documentos y existe customerInfo
useEffect(() => {
  if (!loading && documents.length > 0 && customerInfo) {
    // Evitar error de "possibly null"
    const customerDocName = customerInfo?.document_type || "";

    if (customerDocName !== "") {
      // Buscar por NOMBRE del documento
      const found = documents.find(
        (d: any) => d.document.toLowerCase() === customerDocName.toLowerCase()
      );

      if (found) {
        // Setear tipo de documento
        setValue("document_type", found.code);

        // Aplicar mask automáticamente
        setDocumentMask(found.input_mask);

        // Setear número
        if (customerInfo?.document) {
          setValue("document_number", customerInfo.document);
        }
      }
    }
  }
}, [loading, documents, customerInfo]);


const handleDocumentTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  const selectedDocument = documents.find(
    (doc: any) => doc.code === event.target.value
  );
  if (selectedDocument) {
    setDocumentMask(selectedDocument.input_mask);
  }
};



  const sendDataProfile = async (props: DocumentForm) => {
    // Omitimos email usando destructuring
    const { ...cleanData } = props;

    await editData(cleanData);
  };

  return (
    <Fragment>
      {successMessage && (
        <div
          className="bg-[#E7F8EF] rounded-xl font-medium py-2 px-6 text-[#0E7C3A] mb-3"
          role="alert"
        >
         <p className=" text-sm">{successMessageText}</p> 
        </div>
      )}
      {errorMessage && (
        <div
          className="bg-[#FEE2E2] rounded-xl font-medium py-2 px-6 text-[#B91C1C] mb-3"
          role="alert"
        >
          <p className=" text-sm">{errorMessageText}</p>
        </div>
      )}
      <form
        className="space-y-6 md:space-y-8"
        onSubmit={handleSubmit(sendDataProfile)}
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              {" "}
              Tipo de documento
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Para que tengamos mejor comunicación
            </p>
          </div>

          <div className="w-full md:w-3/4 ">
            {!loading && (
              <Controller
                name="document_type"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Select
                    className="mt-1"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value || ""}
                    onChange={(event: any) => {
                      onChange(event);
                      handleDocumentTypeChange(event);
                    }}
                    sx={{
                      width: "100%",
                      height: "44px",
                      borderColor: "#5F5F5F",
                      borderRadius: "10px",
                      background: "white",
                    }}
                  >
                    {documents &&
                      documents?.length > 0 &&
                      documents?.map((item: DocumentData, index: number) => (
                        <MenuItem key={index} value={item.code}>
                          {item.document}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              />
            )}
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              {" "}
              Número de documento
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Para que tengamos mejor comunicación
            </p>
          </div>

          <div className="w-full md:w-3/4 ">
            <Controller
              control={control}
              name="document_number"
              render={({ field: { ref } }) => (
                <MaskInput
                  ref={ref}
                  register={register}
                  name={"document_number"}
                  mask={documentMask}
                />
              )}
            />
          </div>
        </div>

        <div className="w-full flex justify-end items-center">
          <Button
            type="submit"
            className="w-full lg:w-auto mt-8 ml-auto font-semibold py-3 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
          >
            Actualizar mis datos
          </Button>
        </div>
      </form>
    </Fragment>
  );
};
export default DocumentForm;
